
import Vuex from 'vuex';
import gql from 'graphql-tag'

import graphqlClient from './graphql';
import { fetchMe } from './services/teatroApi';

export const mutations = {
  setUserLog(state, UserLog) {
    state.user_log = UserLog;
  },
  setIsAuthenticatedLog(state, data) {
    state.is_authenticated = data.isAuthenticated;
    state.is_admin = data.isAdmin;
    state.role = data.myRole;
    state.rules = [];
    state.infos = [];
  },
  setMe(state, me) {
    state.me = me;
  },
};

export const actions = {
  async fetchUser({ commit }) {
    const response = await graphqlClient.query({
      query: gql`
        { user {
          id
          username
          is_authenticated:isAuthenticated
        }
        }
      `,
    });
    commit('setUserLog', response.data.user);
  },
  async fetchIsAuthenticated({ commit }) {
    const response = await graphqlClient.query({
      query: gql` {
      isAuthenticated
      isAdmin
      myRole
    }`,
      update: data => [data.isAuthenticated, data.isAdmin, data.myRole]
    });
    commit('setIsAuthenticatedLog', response.data);
  },
  async fetchMe({ commit }) {
    const me = await fetchMe();
    commit('setMe', me);
    return me;
  },
};

export const state = {
  noti: null,
  is_authenticated: false,
  is_admin: false,
  role: null,
  rules: [],
  infos: [],
  me: null,
};

export default new Vuex.Store({
  mutations,
  actions,
  state,
});